// create react context for end of service with useContext hook and with notification list
import { nanoid } from "nanoid";
import React, { ReactNode, useState, useCallback } from "react";
import EndOfService from "./EndOfService";

export type IEndOfServiceNotice =
  | {
      id: string;
      title: string;
      description: string;
      type: "info";
      onClose?: () => void;
    }
  | {
      id: string;
      title: string;
      description: string;
      type: "warning";
      buttonText: string;
      onClose?: () => void;
      onButtonClick?: () => void;
    }
  | {
      id: string;
      title: string;
      description: string;
      type: "modal";
      okText?: string;
      cancelText?: string;
      onClose?: () => void;
    };

interface IEndOfServiceContextState {
  addNotice: (notice: IEndOfServiceNotice) => void;
  removeNotice: (id: string) => void;
  notices: IEndOfServiceNotice[];
}

const EndOfServiceContext = React.createContext<IEndOfServiceContextState>({
  addNotice: () => {},
  removeNotice: () => {},
  notices: [],
});

export const EndOfServiceProvider = ({ children }: { children: ReactNode }) => {
  const [notices, setNotices] = useState<IEndOfServiceNotice[]>([
    // {
    //   type: "info",
    //   id: "1",
    //   title: "Le shop ferme dans 15 minutes !",
    //   description: "Terminez votre commande avant pour garantir votre créneau",
    // },
  ]);

  const addNotice = useCallback((notice: IEndOfServiceNotice) => {
    setNotices((prev) => {
      // Check if notice with same ID already exists
      if (prev.some((n) => n.id === notice.id)) {
        return prev;
      }

      return [
        ...prev,
        {
          ...notice,
          id: notice.id || nanoid(),
        },
      ];
    });
  }, []);

  const removeNotice = useCallback((id: string) => {
    setNotices((prev) => {
      // Trouver la notification pour exécuter onClose si elle existe
      const noticeToRemove = prev.find((notice) => notice.id === id);
      if (noticeToRemove?.onClose) {
        noticeToRemove.onClose();
      }
      return prev.filter((notice) => notice.id !== id);
    });
  }, []);

  const value = {
    addNotice,
    removeNotice,
    notices,
  };

  return (
    <EndOfServiceContext.Provider value={value}>
      <EndOfService />
      {children}
    </EndOfServiceContext.Provider>
  );
};

export const useEndOfService = () => {
  const context = React.useContext(EndOfServiceContext);

  return context || {};
};

export default EndOfServiceProvider;
